import { Line, LineMarkerColors } from '../../@types/lines';

export default function LineColor(lines: Line[], id: number): string {
    const idx = lines
        .filter((value, index, self) => self.map(x => x.Name).indexOf(value.Name) === index)
        .findIndex(line => line.Name === lines.find(line => line.ID === id)?.Name);
    return LineMarkerColors[idx % LineMarkerColors.length];
}
